<template>
    <vFlowConfig01Component :postList="postList" v-if="flag"></vFlowConfig01Component>
</template>
<script>
import vFlowConfig01Component from '../../listComponent/basicdata/flowConfig01/flowConfig01Component.vue';
export default {
    name: 'vFlowConfig01',
    components: {
        vFlowConfig01Component
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                business_rid: true,
                supplier_rid: true,
                product_rid: true,
                date: true,
                status: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                addBtn: true,
                uploadBtn: true,
                matchBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>